import { axiosInstance } from '../axios';


class CorporationSettingsService {

  async getSettings() {
    return await axiosInstance.get(
        '/corporation-settings/settings',
    );
  }

  async save(corporationSettings) {
    return await axiosInstance.post(
        '/corporation-settings/settings',corporationSettings);
  }

  async uploadLogo(logoFile) {
    const formData = new FormData();
    formData.append('logo', logoFile);
    return await axiosInstance.post('/corporation-settings/logo-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async uploadBackground(backgroundFile) {
    const formData = new FormData();
    formData.append('background', backgroundFile);
    return await axiosInstance.post('/corporation-settings/background-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }


  getServedMediaAssetsUrl(){
    return axiosInstance.defaults.baseURL + '/corporation-settings/media/assets';
  }

}

export default new CorporationSettingsService();
